import { connect } from 'react-redux';

import ReviewsMobile from '../../components/Reviews/ReviewsMobile';
import { getHotelStars, getHotelName } from '../../store/selectors/hotel';
import { getBreadcrumbs } from '../../store/selectors/breadcrumbs';

const mapStateToProps = (state) => ({
  breadcrumbs: getBreadcrumbs(state),
  hotelName: getHotelName(state),
  stars: getHotelStars(state),
});

export default connect(mapStateToProps)(ReviewsMobile);
